import styled, { keyframes } from "styled-components";
import { SPACING, ANIMATION, QUERIES } from "../../../../../../utils/constants";

// Transform-only reveal keeps the wipe off the layout path; reduced motion stills it globally.
const barReveal = keyframes`
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
`;

export const CompositionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm + SPACING.xs}px;
  min-width: 0;
`;

export const CompositionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${SPACING.md}px;
`;

export const CompositionTitle = styled.span`
  font-size: var(--text-xs);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-secondary);
`;

export const CompositionCaption = styled.span`
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
`;

export const Bar = styled.div`
  display: flex;
  width: 100%;
  height: 10px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--color-border);
  transform-origin: left center;
  animation: ${barReveal} ${ANIMATION.duration.moderate}
    ${ANIMATION.easing.easeOutExpo} both;
`;

export const BarSegment = styled.div<{ $width: number; $color: string }>`
  width: ${({ $width }) => $width}%;
  background: ${({ $color }) => $color};
`;

export const Legend = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm}px;
`;

export const LegendRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.md}px;
`;

export const LegendLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm}px;
`;

export const Swatch = styled.span<{ $color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export const LegendName = styled.span`
  font-size: var(--text-base);
  color: var(--color-text-default);
`;

export const LegendValue = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${SPACING.sm}px;
`;

export const LegendAmount = styled.span<{ $color?: string }>`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-base);
  font-weight: 600;
  color: ${({ $color }) => $color ?? "var(--color-text-default)"};
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
`;

export const LegendPercent = styled.span`
  font-size: var(--text-xs);
  color: var(--color-text-secondary);
  min-width: 4ch;
  text-align: right;
`;

export const WithdrawnNote = styled.p`
  margin: 0;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
`;

export const InterestBreakdown = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${SPACING.sm}px;
  padding-top: ${SPACING.xs}px;

  @media ${QUERIES.tabletLargeAndUp} {
    gap: ${SPACING.md}px;
    padding-top: ${SPACING.md}px;
    border-top: 1px solid var(--color-border);
  }
`;

export const BreakdownItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
  min-width: 0;
`;

export const BreakdownLabel = styled.span`
  font-size: var(--text-xs);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--color-text-secondary);

  @media ${QUERIES.tabletLargeAndUp} {
    letter-spacing: 0.08em;
  }
`;

export const BreakdownValue = styled.span`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-base);
  font-weight: 700;
  color: var(--color-text-default);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;

  @media ${QUERIES.tabletLargeAndUp} {
    font-size: var(--text-md);
  }
`;
